import { UserAnswersService } from "@/common/api.service"
import { ADD_USER_ANSWERS, RESET_STATE} from "./actions.type"
import { SET_USER_ANSWERS,SET_ERROR_USER_ANSWERS, STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        useranswers: [],
        useranswererrors: null,
    }
}

let state = initialState()

const getters = {
    useranswers(state) {
        return state.useranswers
    }
}

const actions = {
    async [ADD_USER_ANSWERS](context, payload) {
        return await UserAnswersService.create(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER_ANSWERS, error.response.data.errors)
        });
    },  
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_USER_ANSWERS](state, error) {
        state.questionerrors = error
    },      
    [SET_USER_ANSWERS](state, questionsdata) {
        state.questions = questionsdata
    },
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};